<template>
  <section ref="anchor" class="success">
    <div class="font-60-68-bold success__title">{{ content.title }}</div>

    <div class="success__content">
      <div
        v-for="(tile, index) in content.tiles"
        :key="index"
        class="success__content-item"
      >
        <div
          :class="['success__content-block', { 'mod-gray': tile.background }]"
        >
          <div
            v-if="tile.img"
            class="success__content-image"
            v-html="tile.img"
          />

          <div v-if="tile.title" class="font-medium block__subtitle">
            {{ tile.title }}
          </div>

          <div class="block__description">{{ tile.text }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { electronicAdvantagesData } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'ElectronicAdvantages',
  mixins: [offsetMixin],
  data() {
    return {
      content: electronicAdvantagesData,
    }
  },
}
</script>

<style lang="sass" scoped>
.success
  padding: 8rem $desktopHorizontalPaddings 8rem
  @media (max-width: 1023px)
    padding: 4rem $mobileHorizontalPaddings 4rem
  &__title
    margin-bottom: 6rem
    @media (max-width: 1439px)
      margin-bottom: 3.2rem
  &__content
    display: flex
    justify-content: center
    gap: 2rem
    flex-wrap: wrap
    &-item
      display: flex
      flex-direction: column
    @media (max-width: 1023px)
      margin-top: 2.4rem
      gap: 0
      &-item
        width: 100%
        display: flex
        flex-direction: row
        align-items: stretch
        height: auto
        gap: 20px
        margin-bottom: 1.2rem
        .success__content-block
          flex-grow: 1

    @media (min-width: 1024px)
      &-item
        width: calc(20% - 1.6rem)
        margin-bottom: 2rem
        @media (max-width: 1439px)
          width: calc(33.33% - 1.4rem)
        @media (max-width: 1199px)
          width: calc(50% - 1rem)

    &-image
      margin: 0 auto 0 0
      padding-bottom: 0.8rem
      height: 120px
      width: 120px
      object-fit: contain
      ::v-deep svg
        width: 100%
        height: 100%
      @media (max-width: 1023px)
        margin: 0 0 1.6rem 0
        height: 200px
        width: 200px

    &-block
      display: flex
      flex-direction: column
      flex: 1
      @media (max-width: 1023px)
        height: auto
        justify-content: flex-start
      padding: 3.2rem 2.4rem
      border-radius: 20px
      border: 1px solid $backgroundGray
      @media (min-width: 1440px) and (max-width: 1599px)
        padding: 2.2rem 1.4rem
      @media (min-width: 1024px) and (max-width: 1439px)
        padding: 2.2rem 1.4rem
      @media (max-width: 1023px)
        padding: 1.6rem 1.4rem
      .block__description
        font-weight: 500
        @media (min-width: 1024px) and (max-width: 1439px)
          font-size: 1.6rem
        @media (max-width: 1023px)
          font-weight: 400
      &.mod-gray
        background: $backgroundGray
.block__description
  font-family: $secondaryFont
  font-weight: 400
  font-size: 1.6rem
  line-height: 2.2rem
  color: $textSecondary
  @media (max-width: 1024px)
    font-size: 1.4rem
    line-height: 1.8rem

.block__subtitle
  font-family: $primaryFont
  font-weight: 400
  font-size: 2.2rem
  line-height: 3rem
  color: $textPrimary
  padding-bottom: 0.8rem
  @media (min-width: 1440px) and (max-width: 1699px)
    font-size: 2rem
  @media (min-width: 1024px) and (max-width: 1439px)
    font-size: 1.8rem
  @media (max-width: 1024px)
    font-size: 2rem
    line-height: 2.6rem
</style>
